// the 'type' for the clock widget
export const CLOCK_TYPE = 'clock';

// the max number of cities that can be added to the clock widget
export const CITY_LIMIT = 10;
